// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"Gj-z","hideOnMobile":"Hj-z"};